/**
 * @param {String} name
 * @param {Object} [data={}]
 * */
const fireDataLayerPush = (name, data = {}) => {
  try {
    const dataLayer = window?.dataLayer || []
    dataLayer.push({
      event: name,
      ...(data || {}),
    })
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.log(err)
    }
  }
}

export default fireDataLayerPush
